import {
    VENDOR_EMPLOYEE_WELFARE_FUND_FETCHING,
    VENDOR_EMPLOYEE_WELFARE_FUND_FAILED,
    VENDOR_EMPLOYEE_WELFARE_FUND_SUCCESS,
    EMPLOYEE_WELFARE_FUND_FETCHING,
    EMPLOYEE_WELFARE_FUND_FAILED,
    EMPLOYEE_WELFARE_FUND_SUCCESS
} from "./types";

import employeeWelfareFundService from "../services/employee-welfare-fund.service";

export const getVendorEWFSetting = () => async (dispatch) => {
  try {
    dispatch({
      type: VENDOR_EMPLOYEE_WELFARE_FUND_FETCHING
    });
    const res = await employeeWelfareFundService.getVendorEWFSetting();
    if(res){
        dispatch({
            type: VENDOR_EMPLOYEE_WELFARE_FUND_SUCCESS,
            payload: res.data
        });
    }
  } catch (error) {
    dispatch({
      type: VENDOR_EMPLOYEE_WELFARE_FUND_FAILED
    });
  }
};

export const getEmployeeEWFByidEmp = (idEmp) => async (dispatch) => {
  try {
    dispatch({
      type: EMPLOYEE_WELFARE_FUND_FETCHING
    });
    const res = await employeeWelfareFundService.getEmployeeEWFByidEmp(idEmp);
    if(res){
        dispatch({
            type: EMPLOYEE_WELFARE_FUND_SUCCESS,
            payload: res.data
        });
    }
  } catch (error) {
    dispatch({
      type: EMPLOYEE_WELFARE_FUND_FAILED
    });
  }
};

export const joinEmployeeEWF = (data) => async () => {
  try {
    const res = await employeeWelfareFundService.joinEmployeeEWF(data);
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const leftEmployeeEWF = (data) => async () => {
  try {
    const res = await employeeWelfareFundService.leftEmployeeEWF(data);
    if (res) {
      return res;
    }
  } catch (error) {
    return error;
  }
};

export const dumpExcelEmployeeWelfareFundByVendor = (data) => async () => {
  try {
    const res = await employeeWelfareFundService.dumpExcelEmployeeWelfareFundByVendor(data);
    if (res) {
      return res.data;
    }
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
  }
};